export default "__VITE_ASSET__BnP1zExA__"